import Text from 'components/_UI/Text';
import DynamicProfileImage from 'components/commons/DynamicProfileImage';
import React from 'react';
import { Phone, Mail, FileText } from 'lucide-react';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import fonts from 'theme/fonts';

export default function CardProducerProfile({ data }) {

  function formatPhone(number) {
    if (!number) return '';
    const cleaned = number.replace(/\D/g, '');

    if (cleaned.length === 10) {
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    if (cleaned.length === 11) {
      return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    return number;
  }

  function formatCpfCnpj(value) {
    if (!value) return '';
    const cleaned = value.replace(/\D/g, '');

    if (cleaned.length === 11) {
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    if (cleaned.length === 14) {
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return value;
  }

  return (
    <Container>
      <ProfileHeader>
        <AvatarContainer>
          <DynamicProfileImage
            img={data?.photoImage?.path}
            size={'80px'}
            word={data?.name}
          />
        </AvatarContainer>

        <Text name='subtitle' paddingBottom={0}>
          {data?.name}
        </Text>

        <Text textAlign={'center'}>
          {data?.description}
        </Text>
      </ProfileHeader>

      <InfoSection>
        {data?.phone && (
          <InfoRow>
            <InfoIcon>
              <Phone size={'18px'} color={colors.primaryLight} />
            </InfoIcon>
            <Text color={colors.nightDark}>
              {formatPhone(data?.phone)}
            </Text>
          </InfoRow>
        )}

        {data?.email && (
          <InfoRow>
            <InfoIcon>
              <Mail size={'18px'} color={colors.primaryLight} />
            </InfoIcon>
            <Text color={colors.nightDark}>
              {data?.email}
            </Text>
          </InfoRow>
        )}

        {data?.cpf_cnpj && (
          <InfoRow>
            <InfoIcon>
              <FileText size={'18px'} color={colors.primaryLight} />
            </InfoIcon>
            <Text color={colors.nightDark}>
              {formatCpfCnpj(data?.cpf_cnpj)}
            </Text>
          </InfoRow>
        )}
      </InfoSection>
    </Container>
  );
}

const Container = styled(Column)`
  background: ${colors.neutralLight};
  border-radius: 12px;
  width: 100%;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);

  @media screen and (min-width: ${breakpoints.lg}) {
    width: 32.5%;
  }
`;

const ProfileHeader = styled(Column)`
  width: 100%;
  align-items: center;
  padding: 32px 16px 16px 16px;

  @media screen and (min-width: ${breakpoints.md}) {
    padding: 32px 20px 16px 20px;
  }
`;

const AvatarContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 16px;
  box-shadow: 0 0 0 3px ${colors.primaryLight};

  & > picture > img {
    object-fit: cover;
  }
`;

const InfoSection = styled(Column)`
  width: 100%;
  padding: 0 16px 24px 16px;
  gap: 12px;

  @media screen and (min-width: ${breakpoints.md}) {
    padding: 0 20px 24px 20px;
  }
`;

const InfoRow = styled(Row)`
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(79, 134, 247, 0.06);

  & > p {
    padding-bottom: 0;
  }
`;

const InfoIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(79, 134, 247, 0.1);
`;
